export default __webpack_public_path__ + "static/media/logo.dbafa977.svg";